import { breadcrumbScript } from "@/lib/seo-jsonld";
import { createFileRoute, Link } from "@tanstack/react-router";
import { Megaphone, Store, Sparkles, Percent } from "lucide-react";
import { Button } from "@/components/ui/button";
import { subcategoriesOf } from "@/lib/data";

export const Route = createFileRoute("/reklam")({
  head: () => ({
    meta: [
      { title: "Reklam yerləşdir — biznes və mağaza reklamı | Albazar.az" },
      {
        name: "description",
        content:
          "Biznesinizi, mağazanızı, xidmətinizi və kampaniyalarınızı Albazar.az-da reklam edin. Pulsuz elan yerləşdir, minlərlə istifadəçiyə çat.",
      },
      { property: "og:title", content: "Reklam yerləşdir — Albazar.az" },
      {
        property: "og:description",
        content: "Biznes, mağaza, xidmət və kampaniya reklamları üçün ayrıca bölmə.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://albazar.az/reklam" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://albazar.az/reklam" }],
    scripts: [breadcrumbScript([{ name: "Reklam", path: "/reklam" }])],
  }),
  component: AdvertisePage,
});

const perks = [
  { icon: Store, title: "Mağaza və biznes", text: "Şirkətinizi, mağazanızı və ünvanınızı tanıdın." },
  { icon: Sparkles, title: "Xidmətlər", text: "Təklif etdiyiniz xidmətləri geniş auditoriyaya çatdırın." },
  { icon: Percent, title: "Kampaniya və endirim", text: "Aksiyalarınızı dərhal elan edin." },
];

function AdvertisePage() {
  const subs = subcategoriesOf("reklam");
  return (
    <div className="container-x py-8">
      <div className="rounded-[20px] border border-border bg-card p-6 shadow-card">
        <div className="flex items-center gap-3">
          <span className="grid size-11 place-items-center rounded-2xl bg-primary/10 text-primary">
            <Megaphone className="size-6" />
          </span>
          <div>
            <h1 className="text-2xl font-extrabold tracking-tight sm:text-3xl">Reklam yerləşdir</h1>
            <p className="text-sm text-muted-foreground">
              Bizneslərinizi, mağazalarınızı, xidmətlərinizi və kampaniyalarınızı reklam edin.
            </p>
          </div>
        </div>
        <Button asChild className="mt-5 h-11 rounded-full px-6 font-bold">
          <Link to="/yeni-elan" search={{ kateqoriya: "reklam" }}>
            Reklam elanı yerləşdir
          </Link>
        </Button>
      </div>

      <div className="mt-6 grid gap-3 sm:grid-cols-3">
        {perks.map((p) => (
          <div key={p.title} className="rounded-[18px] border border-border bg-card p-4 shadow-card">
            <p.icon className="size-5 text-primary" />
            <p className="mt-2 font-bold">{p.title}</p>
            <p className="mt-1 text-sm text-muted-foreground">{p.text}</p>
          </div>
        ))}
      </div>

      <h2 className="mt-8 text-lg font-bold">Reklam növləri</h2>
      <div className="mt-3 flex flex-wrap gap-2">
        {subs.map((s) => (
          <Link
            key={s.slug}
            to="/kateqoriya/$slug"
            params={{ slug: "reklam" }}
            search={{ alt: s.slug, marka: "" }}
            className="rounded-full border border-border px-4 py-1.5 text-sm font-medium transition-colors hover:border-primary/50 hover:bg-accent"
          >
            {s.name}
          </Link>
        ))}
      </div>
    </div>
  );
}